<section class="homepage-cta">
  <div>
    <i class="bi bi-trophy-fill"></i>
    <h2>{{ $t('publicCta.title') }}</h2>
    <p>{{ $t('publicCta.description') }}</p>
  </div>
  <router-link :to="{ name: 'About', hash: '#contacts' }" class="homepage-btn homepage-btn--primary">
    {{ $t('publicCta.action') }}
  </router-link>
  <ul>
    <li v-for="item in ctaItems" :key="item"><i class="bi bi-check2"></i>{{ $t(`publicCta.items.${item}`) }}</li>
  </ul>
</section>
